import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import moment from "moment";

import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import ModelOptionCard from "../../components/ModelOptionCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { setEdu, setFree, setLicenseGroup } from '../../redux/licenseSlice';
import { numFormat, refreshLicenseData } from '../../libs/utils';

export default function Profile() {
    const location = useLocation();

    const lang = useSelector(state => state.langReducer.lang);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);

    const fileRef = useRef();

    const [detailView1, setDetailView1] = useState(false);
    const [detailView2, setDetailView2] = useState(false);
    const [detailView3, setDetailView3] = useState(false);
    const [detailView4, setDetailView4] = useState(false);

    const [payList, setPayList] = useState([]);
    const [cardList, setCardList] = useState([]);
    const [mainCard, setMainCard] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const filterExpired = (license) => {
        const today = new Date();
        if (license.revokedAt) {
            const revokedDate = new Date(license.revokedAt);
            if (revokedDate < today) return false;
        }
        else if (license.licenseGroup && license.licenseGroup.expiredAt) {
            const expiredDate = new Date(license.licenseGroup.expiredAt);
            if (expiredDate < today) return false;
        }
        return true;
    };

    const [groupPro, setGroupPro] = useState([]);
    const [groupArt, setGroupArt] = useState([]);
    const [groupAll, setGroupAll] = useState([]);
    const [free, setFree] = useState(undefined);
    const [hasLicense, setHasLicense] = useState(false);
    

    const fetchLicenseList = async () => {
        dispatch(loadingStart());
        const res = await API.get(`license/user/${mbData.idx}`);

        const pro = res.data.filter(item => item.licenseGroup?.licenseCategory === 0).filter(filterExpired);
        const art = res.data.filter(item => item.licenseGroup?.licenseCategory === 1).filter(filterExpired);
        const all = res.data.filter(item => item.licenseGroup?.licenseCategory === 2).filter(filterExpired);
        const edu = res.data.filter(item => item.licenseGroup === null || item.licenseGroup?.licenseCategory === 3).filter(filterExpired);

        setGroupArt(art);
        setGroupAll(all);
        dispatch(setEdu(edu.length > 0 ? edu[0] : undefined));

        const freeData = (await API.get(`license/user/free/${mbData.idx}`)).data;

        if (!freeData || freeData === "") {
            setFree(undefined);
        } else {
            setFree(freeData);
        }

        console.log("free : ", freeData);
        const sum = [...(pro || []), freeData].filter(item => item !== "" && moment(item?.licenseGroup?.expiredAt).format('YYYY-MM-DD HH:mm:ss') > moment().format('YYYY-MM-DD HH:mm:ss'));
        setGroupPro(sum);
        console.log("sum : ", sum, ", pro : ", pro);

        setHasLicense(sum.length > 0 || art.length > 0 || all.length > 0 || edu[0]);

        const result = await API.xsollaApis("user/subscribepaylist", {idx: mbData?.idx});
        //setMainCard();
        result?.result?.paylist?.map((x, i) => {
            x.plan = result?.result?.lists?.find(item => item?.id*1 === x?.subscriptionId)?.plan;
            x.showWon = result?.result?.lists?.find(item => item?.id*1 === x?.subscriptionId)?.showWon;
        });
        setPayList(result?.result?.paylist?.filter(item => item?.ingstate*1 === 1 || item?.ingstate*1 === 2));
        
        const resultcard = await API.xsollaApis("user/XsolaApiCardlist", {idx: mbData?.idx});
        //setMainCard(result?.result);
        setMainCard(resultcard?.result);
        
        dispatch(loadingEnd());
    }
    const edu = useSelector((s) => s.licenseReducer.edu);

    useEffect(() => {
        if (!mbData?.idx) {
            navigate(routes.main);
        } else {
            fetchLicenseList();
        }
    }, [mbData]);

    return (
        <>
            <div className="main_back">
                <div className="mypage_header">
                    <div className="profile_box">
                        <img className="profile_img" src={require("../../assets/icon/Avatar.svg").default} />

                        <div className="profile_info_box">
                            <p className="name">{mbData?.mb_name || (lang === 0 ? '이름을 설정해 주세요.' : 'Please set your name.')}</p>
                            <div className="email_box">
                                {mbData?.mb_type == 1 &&
                                    <div className="google_logo">
                                        <img src={require("../../assets/icon/google_logo.svg").default} />
                                    </div>
                                }
                                <p className="email">{mbData?.mb_email}</p>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => {
                                navigate(routes.ProfileEdit)
                            }}
                        >
                            <img src={require("../../assets/icon/profile_edit.svg").default} />
                            <span>{lang === 0 ? '프로필 수정' : 'Edit Profile'}</span>
                        </button>
                    </div>
                </div>

                <div className="main_part profile padding">
                    <div className="profile_part_box">
                        <div className="profile_part top">
                            <div className="title_box">
                                <div className="title">
                                    <img src={require("../../assets/icon/mypage_shop.svg").default} />
                                    <p>{lang === 0 ? '라이선스 관리' : 'License Management'}</p>
                                </div>

                                <div
                                    className={`detail ${detailView1 ? 'on' : ''}`}
                                    onMouseEnter={() => {
                                        setDetailView1(true)
                                    }}
                                    onMouseLeave={() => {
                                        setDetailView1(false)
                                    }}
                                    onClick={() => {
                                        navigate(routes.Licensing);
                                    }}
                                >
                                    <p>{lang === 0 ? '자세히보기' : 'View Details'}</p>
                                    {detailView1 ?
                                        <img src={require("../../assets/icon/right_arr_on.svg").default} />
                                        :
                                        <img src={require("../../assets/icon/right_arr_gray.svg").default} />
                                    }
                                </div>
                            </div>

                            <div className="content_box license" style={{ flex: 1, }}>
                                {
                                    !hasLicense ?
                                        <span className="content_none">{lang === 0 ? '내역이 없습니다.' : 'No records found.'}</span>
                                        :
                                        <>
                                            {groupPro.length > 0 && <div className="profile_license_list">
                                                <p className="name">UModeler X Pro</p>

                                                <div className="sub_box">
                                                    <p>{lang === 0 ? '활성' : 'Active'}</p>
                                                    {/* <span>{groupPro.length}</span> */}
                                                </div>
                                            </div>}

                                            {groupArt.length > 0 && <div className="profile_license_list">
                                                <p className="name">UModeler X Art Pass</p>

                                                <div className="sub_box">
                                                    <p>{lang === 0 ? '라이선스' : 'Licenses'}</p>
                                                    <span>{groupArt.length}</span>
                                                </div>
                                            </div>}

                                            {groupAll.length > 0 && <div className="profile_license_list">
                                                <p className="name">UModeler X All-In-One</p>

                                                <div className="sub_box">
                                                    <p>{lang === 0 ? '라이선스' : 'Licenses'}</p>
                                                    <span>{groupAll.length}</span>
                                                </div>
                                            </div>}

                                            {edu && <div className="profile_license_list">
                                                <p className="name">UModeler X School</p>

                                                <div className="sub_box">
                                                    {/* <p>{lang === 0 ? '라이선스' : 'Licenses'}</p> */}
                                                    {/* <span>{edu ? 1 : 0}</span> */}
                                                    <p>{lang === 0 ? '활성' : 'Active'}</p>
                                                </div>
                                            </div>}
                                        </>
                                }

                                {/* <ModelOptionCard /> */}
                            </div>
                        </div>

                        <div className="profile_part">
                            <div className="title_box">
                                <div className="title">
                                    <img src={require("../../assets/icon/mypage_pay.svg").default} />
                                    <p>{lang === 0 ? '결제 내역' : 'Payment History'}</p>
                                </div>

                                <div
                                    className={`detail ${detailView2 ? 'on' : ''}`}
                                    onMouseEnter={() => {
                                        setDetailView2(true)
                                    }}
                                    onMouseLeave={() => {
                                        setDetailView2(false)
                                    }}
                                    onClick={() => {
                                        navigate(routes.PayList)
                                    }}
                                >
                                    <p>{lang === 0 ? '자세히보기' : 'View Details'}</p>
                                    {detailView2 ?
                                        <img src={require("../../assets/icon/right_arr_on.svg").default} />
                                        :
                                        <img src={require("../../assets/icon/right_arr_gray.svg").default} />
                                    }
                                </div>
                            </div>

                            <div className="content_box">
                                {payList?.length > 0 ?
                                    <div className="my_content pay">
                                        {payList?.filter((item, index) => index < 4)?.map((x, i) => {
                                            let showWon = x?.showWon;
                                            return (
                                                <div className="pay_info">
                                                    <p>• [UModeler X {x?.plan}] {(showWon === 'KRW' ? '' : 'USD ')}{numFormat(x?.pay_price)}{(showWon === 'KRW' ? lang === 0 ? '원' : 'KRW' : '')}</p>
                                                    <span>{moment(x?.pay_dt).format('YYYY-MM-DD')}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                :
                                    <span className="content_none">{lang === 0 ? '내역이 없습니다.' : 'No records found.'}</span>
                                }
                            </div>
                        </div>

                        <div className="profile_part">
                            <div className="title_box">
                                <div className="title">
                                    <img src={require("../../assets/icon/mypage_card.svg").default} />
                                    <p>{lang === 0 ? '카드 관리' : 'Card Management'}</p>
                                </div>

                                <div
                                    className={`detail ${detailView3 ? 'on' : ''}`}
                                    onMouseEnter={() => {
                                        setDetailView3(true)
                                    }}
                                    onMouseLeave={() => {
                                        setDetailView3(false)
                                    }}
                                    onClick={() => {
                                        navigate(routes.CardList)
                                    }}
                                >
                                    <p>{lang === 0 ? '자세히보기' : 'View Details'}</p>
                                    {detailView3 ?
                                        <img src={require("../../assets/icon/right_arr_on.svg").default} />
                                        :
                                        <img src={require("../../assets/icon/right_arr_gray.svg").default} />
                                    }
                                </div>
                            </div>

                            <div className="content_box">
                                {mainCard ?
                                <div className="my_content pay">
                                    <div className="pay_info card">
                                        <div className="on">
                                            <img src={require("../../assets/icon/Card.svg").default}/>
                                            <p>{mainCard?.cardName}</p>
                                            <span>{ lang === 0 ? '결제카드' : 'Payment card'}</span>
                                        </div>
                                    </div>
                                </div>
                                :
                                <span className="content_none">{lang === 0 ? '내역이 없습니다.' : 'No records found.'}</span>
                                }
                            </div>
                        </div>

                        {/* <div className="profile_part">
                            <div className="title_box">
                                <div className="title">
                                    <img src={require("../../assets/icon/mypage_inquiry.svg").default}/>
                                    <p>문의 내역</p>
                                </div>

                                <div 
                                    className={`detail ${detailView4 ? 'on' : ''}`}
                                    onMouseEnter={() => {
                                        setDetailView4(true)
                                    }}
                                    onMouseLeave={() => {
                                        setDetailView4(false)
                                    }}
                                    onClick={() => {
                                        navigate(routes.InquiryList)
                                    }}
                                >
                                    <p>자세히보기</p>
                                    {detailView4 ? 
                                        <img src={require("../../assets/icon/right_arr_on.svg").default}/>
                                        :
                                        <img src={require("../../assets/icon/right_arr_gray.svg").default}/>
                                    }
                                </div>
                            </div>

                            <div className="content_box">
                                <div className="my_content pay">
                                    <div className="inquiry_list">
                                        <p>[미답변]</p>
                                        <span>문의내용입니다.문의내용입니다.문의내용입니다.문의내용입니다.</span>
                                    </div>

                                    <div className="inquiry_list on">
                                        <p>[답변완료]</p>
                                        <span>문의내용입니다.문의내용입니다.문의내용입니다.문의내용입니다.</span>
                                    </div>

                                    <div className="inquiry_list">
                                        <p>[미답변]</p>
                                        <span>문의내용입니다.</span>
                                    </div>
                                </div>
                                <span className="content_none">내역이 없습니다.</span>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}